import { AtlBrowserStorageLocal } from '@atlassian/browser-storage-controls/web-storage-service';

import { HOLDOUT_MS, LS_ONBOARDING_HOLDOUT_KEY, MAX_ONBOARDING_EXPOSURES } from './constants';
import { parseState } from './parseState';

/**
 * True if holdout rules allow showing onboarding: not within 24h cooldown,
 * under max exposures (3), and user has not completed onboarding.
 *
 * Returns false when AtlBrowserStorageLocal is unavailable or data is corrupt,
 * only returns true for first-time users (no key) or valid passing state.
 */
export function passesOnboardingHoldout(): boolean {
	try {
		const raw = AtlBrowserStorageLocal.getItem(LS_ONBOARDING_HOLDOUT_KEY);

		if (raw === null) {
			return true;
		}

		const state = parseState(raw);
		if (state === null) {
			return false;
		}

		if (state.onboardingCompleted || state.exposureCount >= MAX_ONBOARDING_EXPOSURES) {
			return false;
		}
		return Date.now() - state.lastSeenAt >= HOLDOUT_MS;
	} catch {
		return false;
	}
}
